import Vue from 'vue';
import find from './find';

// When the request succeeds
const success = (resolve) => {
  find();
  resolve();
};

// When the request fails
const failed = (error, reject) => {
  reject('error');
};

export default (userId, data) => {
  const p = new Promise((resolve, reject) => {
    Vue.$http.post(`/account/${userId}/update_product_index_settings`, data)
    .then(() => {
      success(resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  });
  return p;
};



// WEBPACK FOOTER //
// ./src/app/services/account/updateProductIndexSettings.js